/**
 * D1 — as frases do "colar o link novo". Tradução do desfecho que o servidor decidiu; a tela
 * não confere link nenhum (quem confere é o WhatsApp, no servidor).
 */
import type { PasteInviteResult } from '../../lib/api';

export type PasteFeedback =
  { kind: 'success'; title: string; description: string } | { kind: 'error'; message: string };

export function pasteInviteFeedback(result: PasteInviteResult): PasteFeedback {
  switch (result.status) {
    case 'RESOLVED':
      return {
        kind: 'success',
        title: 'Link atualizado',
        description: 'O grupo voltou ao rodízio.',
      };
    case 'WRONG_GROUP':
      return {
        kind: 'error',
        message: result.otherGroupName
          ? `Este link é de outro grupo (${result.otherGroupName}).`
          : 'Este link é de outro grupo.',
      };
    case 'INVALID':
      return { kind: 'error', message: 'Link expirado ou inválido.' };
    case 'MALFORMED':
      return {
        kind: 'error',
        message: 'Isto não parece um link de grupo do WhatsApp (chat.whatsapp.com/…).',
      };
    case 'UNCONFIRMED':
      return {
        kind: 'error',
        message: 'Não conseguimos confirmar agora. O incidente continua aberto.',
      };
  }
}
